import { useState, useEffect } from "react";
import "../../styles/Navbar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomSelect from "../common/CustomSelect";
import dashIcon from "../../assets/space_dashboard.png";
import reportIcon from "../../assets/insert_chart.png";
import actionIcon from "../../assets/bottom_right_click.png";
import upcomingIcon from "../../assets/chronic.png";
import { handleError, handleSuccess } from "../../utils/Service/utils";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import GTranslateWidget from "../../utils/widgets/GTranslateWidget";
import useClientAdmin from "../../utils/hooks/IsClientAdmin";
import { Button, Divider, Modal, Spin, Tooltip } from "antd";
import { DownOutlined, PoweroffOutlined } from "@ant-design/icons";
import newStyled from "@emotion/styled";
import { Dropdown, Menu } from "antd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTenantContext } from "../../utils/Context/TenantsContext";
import { useFetchFunction } from "../../utils/hooks/UseFetchUrl";
import { base_url } from "../../utils/apiConfig";

const reportTabs = [
  "auditBrowser",
  "reportbrowser",
  "storebrowser",
  "store-performance",
  "net-promoter-score",
  "question-performance",
];

const Navbar = () => {
  const tenant = useTenantContext();
  const location = useLocation();
  const navigate = useNavigate();
  const { isClientAdmin, clientId } = useClientAdmin();
  const { data: configData, getData: getConfigData } = useFetchFunction();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 589);
  const [isDrop, setIsDrop] = useState(window.innerWidth <= 1289);
  const [menuClicked, setMenuClicked] = useState(false);
  const [isAiVisible, setIsAiVisible] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [clientData, setClientData] = useState(null);
  const [clientMailTure, setClientMailTrue] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLogoLoading, setIsLogoLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [active, setActive] = useState(
    localStorage.getItem("activeTab") || "dashboard",
  );
  const [activeMainTab, setActiveMainTab] = useState(
    localStorage.getItem("activeMainTab") || "dashboard",
  );

  // =============================== useEffects =========================================
  useEffect(() => {
    getConfigData("/config");
  }, []);

  useEffect(() => {
    const storedDetails = localStorage.getItem("userDetails");

    if (storedDetails) {
      const userDetails = JSON.parse(storedDetails);

      if (userDetails?.client) setClientData(userDetails.client);
      if (userDetails?.client?.logo_url)
        setLogoUrl(userDetails.client.logo_url);
    }

    setTimeout(() => setIsLogoLoading(false), 500);
  }, []);

  useEffect(() => {
    const savedActive = localStorage.getItem("activeTab");
    const savedMainTab = localStorage.getItem("activeMainTab");
    const savedReportTab = localStorage.getItem("activeReportTab");

    if (savedMainTab === "report") {
      setActiveMainTab("report");
      setActive(savedReportTab);
    } else if (savedActive) {
      setActive(savedActive);
      setActiveMainTab(savedMainTab || "dashboard");
    } else {
      setActive("dashboard");
      setActiveMainTab("dashboard");
    }

    if (savedActive !== "report" || savedMainTab !== "report") {
      setActiveMenu("");
    }
  }, [activeMainTab]);

  useEffect(() => {
    const savedActive = localStorage.getItem("activeTab");
    const savedMainTab = localStorage.getItem("activeMainTab");
    if (location.pathname === "/dashboard") {
      setActive("dashboard");
      setActiveMainTab("dashboard");
      localStorage.setItem("activeTab", "dashboard");
      localStorage.setItem("activeMainTab", "dashboard");
    } else if (savedMainTab === "report") {
      setActiveMainTab("report");
      setActive(savedActive);
    } else if (savedActive) {
      setActive(savedActive);
      setActiveMainTab(savedMainTab || "dashboard");
    } else {
      setActive("dashboard");
      setActiveMainTab("dashboard");
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleResizeMob = () => {
      setIsMobile(window.innerWidth <= 589);
    };
    const handleResizeDrop = () => {
      setIsDrop(window.innerWidth <= 1289);
    };
    window.addEventListener("resize", handleResizeMob);
    window.addEventListener("resize", handleResizeDrop);
  }, []);

  useEffect(() => {
    setActiveMainTab("dashboard");
  }, []);

  // =============================== Functions =========================================
  const getClientLogo = (client) => {
    const logoAttachment = client?.attachments?.find(
      (att) => att.attachment_category === "CLIENT_LOGO",
    );

    return (
      logoAttachment?.extra?.thumbnail_url || client?.logo_url || tenant?.logo7x
    );
  };

  const handleActive = (activeTab) => {
    if (active === activeTab) return;
    setActive(activeTab);
    localStorage.setItem("activeTab", activeTab);

    if (reportTabs.includes(activeTab)) {
      setActiveMainTab("report");
      localStorage.setItem("activeMainTab", "report");
      localStorage.setItem("activeTab", activeTab);
    } else {
      setActiveMainTab(activeTab);
      localStorage.setItem("activeMainTab", activeTab);
    }
    navigate(`/${activeTab}`);

    if (activeTab === "ai-overall-report-analysis") {
      setIsAiVisible(true);
    } else {
      setIsAiVisible(false);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const handleCheckbox = (e) => {
    setClientMailTrue(e.target.checked);
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("Authentication token is missing.");
        return;
      }
      const payload = { receive_email_notification: clientMailTure };
      const response = await axios.post(
        // "https://portal.floorwalk.in/client/email_notification",
        `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/email_notification`,
        payload,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        },
      );
      if (response.status === 200) {
        handleSuccess("Successfully saved email notification preference");
      } else {
        handleError("Failed to save preference:", response.data);
      }
      closeModal();
    } catch (error) {
      handleError("Check your internet connection", error);
    }
  };

  const handleMenu = () => {
    setMenuClicked(!menuClicked);
  };

  const handleLogOut = async () => {
    setLoading(true);
    setActiveMainTab("dashboard");
    setActive("dashboard");
    const fullUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/market_place/logout_api`;
    const token = localStorage.getItem("authToken");
    try {
      await axios.post(
        fullUrl,
        {},
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        },
      );
      localStorage.removeItem("authToken");
      localStorage.removeItem("activeTab");
      localStorage.removeItem("activeMainTab");
      localStorage.removeItem("userDetails");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("userEmailDetails");
      localStorage.removeItem("reportId");
      localStorage.removeItem("sections");
      localStorage.removeItem("selectedAuditId");
      localStorage.removeItem("percentage");
      localStorage.removeItem("searchResults");
      handleSuccess("Logout successful");
      navigate("/login", { replace: true });
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch (error) {
      console.log("An error occurred:", error);
      handleError("Logout unsuccessful");
    } finally {
      setLoading(false);
    }
  };

  const handleClickLogo = () => {
    setActive("dashboard");
    setActiveMainTab("dashboard");
    localStorage.setItem("activeTab", "dashboard");
    localStorage.setItem("activeMainTab", "dashboard");
    navigate("/dashboard");
  };

  const handleMenuClick = (key) => {
    setActiveMenu(key);
    if (key !== "dashboard") {
      setActiveMainTab(key);
      setActive(key);
    }

    const selectedTab = tabItems.find((item) => item.key === key);
    if (selectedTab) {
      navigate(selectedTab.path);
    }
  };

  const tabItems = [
    {
      key: "auditBrowser",
      label: "Audit Browser",
      path: "/auditBrowser",
    },
    { key: "reportbrowser", label: "Section Browser", path: "/reportbrowser" },
    { key: "storebrowser", label: "Store Browser", path: "/storebrowser" },
    {
      key: "store-performance",
      label: "Store Performance",
      path: "/store-performance",
    },
    {
      key: "question-performance",
      label: "Question Performance",
      path: "/question-performance",
    },

    ...(clientId !== 378
      ? [
          {
            key: "net-promoter-score",
            label: "Net Promoter Score",
            path: "/net-promoter-score",
          },
        ]
      : []),
  ];

  const filteredReportTabs = isClientAdmin
    ? tabItems
    : tabItems.filter(
        (tab) =>
          tab.key !== "store-performance" && tab.key !== "net-promoter-score",
      );

  const menu = (
    <Menu
      onClick={(e) => {
        handleMenuClick(e.key);
        setActive("report");
        setActiveMainTab("report");
        localStorage.setItem("activeTab", "report");
        localStorage.setItem("activeMainTab", "report");
      }}
      selectedKeys={activeMenu}
    >
      {filteredReportTabs.map((tab) => (
        <Menu.Item
          key={tab.key}
          onClick={() => handleActive(tab.key)}
          className={active === tab.key ? "bg-active" : ""}
        >
          {tab.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  // const menuAi = (
  //   <Menu>
  //     <Menu.Item
  //       key="1"
  //       onClick={() => {
  //         setActive("ai-overall-report-analysis");
  //         setActiveMainTab("ai");
  //         localStorage.setItem("activeTab", "ai-overall-report-analysis");
  //         localStorage.setItem("activeMainTab", "ai");
  //         navigate("/ai-overall-report-analysis");
  //       }}
  //     >
  //       Overall report analysis
  //     </Menu.Item>
  //     <Menu.Item
  //       key="2"
  //       onClick={() => {
  //         setActive("ai-keyword-analysis");
  //         setActiveMainTab("ai");
  //         localStorage.setItem("activeTab", "ai-keyword-analysis");
  //         localStorage.setItem("activeMainTab", "ai");
  //         navigate("/ai-keyword-analysis");
  //       }}
  //     >
  //       Extracted keywords analysis
  //     </Menu.Item>
  //   </Menu>
  // );

  return (
    <div className="no-print">
      <nav className="header navbar navbar-expand-lg">
        <div className="container-fluid d-flex">
          <div style={{ position: "relative", width: "100px", height: "auto" }}>
            {isLogoLoading && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <Spin size="small" />
              </div>
            )}
            {!isLogoLoading && (
              <div className="logo-wrapper" onClick={handleClickLogo}>
                <img
                  src={getClientLogo(clientData)}
                  alt="Brand Logo"
                  className="logo"
                />
              </div>
            )}
          </div>

          {isDrop ? (
            <CustomSelect isClientAdmin={isClientAdmin} clientId={clientId} />
          ) : (
            <div className="d-flex flex-wrap justify-content-evenly align-content-between gap-4 ">
              <Link
                to="/dashboard"
                className={`dashboard gap-2 ${
                  active === "dashboard" ? "bg-active" : "bg-inactive"
                }`}
                onClick={() => handleActive("dashboard")}
              >
                <div className="iconList df">
                  <img src={dashIcon} alt="img" />
                </div>
                <p>Dashboard</p>
              </Link>
              <Dropdown overlay={menu} trigger={["click"]}>
                <Link
                  to="#"
                  className={`reportbrowser gap-2 ${
                    filteredReportTabs.some(
                      (tab) => tab.key === activeMainTab,
                    ) || activeMainTab === "report"
                      ? "bg-active"
                      : "bg-inactive"
                  }`}
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="iconChart df">
                    <img src={reportIcon} alt="img" />
                  </div>
                  <p>Reports</p>
                  <DownOutlined />
                </Link>
              </Dropdown>
              <Link
                to="/actiontrack-report"
                className={`actiontrack-report gap-2 ${
                  active === "actiontrack-report" ? "bg-active" : "bg-inactive"
                }`}
                onClick={() => handleActive("actiontrack-report")}
              >
                <div className="iconAction df">
                  <img src={actionIcon} alt="img" />
                </div>
                <p>Action Track</p>
              </Link>

              {isClientAdmin && clientId !== 166 && (
                <Link
                  to="/up-coming-audits"
                  className={`up-coming-audits gap-2 ${
                    active === "up-coming-audits" ? "bg-active" : "bg-inactive"
                  }`}
                  onClick={() => handleActive("up-coming-audits")}
                >
                  <div className="iconClock df">
                    <img src={upcomingIcon} alt="img" />
                  </div>
                  <p>Upcoming audits</p>
                </Link>
              )}

              {isClientAdmin && (
                <Link
                  to="/ai-overall-report-analysis"
                  className={
                    active === "ai-overall-report-analysis"
                      ? "up-coming-audits ai-active"
                      : "ai-inactive"
                  }
                  onClick={() => handleActive("ai-overall-report-analysis")}
                >
                  <div className="iconStar">
                    <i className="bi bi-stars"></i>
                  </div>
                  <p>AI Insights</p>
                </Link>
              )}

              {/* {isClientAdmin && (
                <Dropdown overlay={menuAi} trigger={["click"]}>
                  {[
                    "ai-overall-report-analysis",
                    "ai-keyword-analysis",
                  ].includes(active) ? (
                    <div className="view-Ai d-flex gap-1 my-2 justify-content-center align-items-center">
                      <div className="iconStar my-2">
                        <i className="bi bi-stars"></i>
                      </div>
                      <p className="my-2">
                        AI Insights
                        <DownOutlined style={{ color: "#ffffff" }} />
                      </p>
                    </div>
                  ) : (
                    <div className="ai df">
                      <i className="bi bi-stars"></i>
                      <p className="my-2">
                        AI Insights{" "}
                        <DownOutlined style={{ color: "#007dc1" }} />
                      </p>
                    </div>
                  )}
                </Dropdown>
              )} */}
            </div>
          )}

          {!isMobile ? (
            <div className="collNav">
              <div className="collInner d-flex justify-content-end gap-3">
                <Tooltip title="Email Notification" placement="bottom">
                  <div
                    className="bellIcon d-flex align-items-center justify-content-center"
                    onClick={showModal}
                  >
                    <i className="bi bi-bell"></i>
                  </div>
                </Tooltip>
                <div
                  className="globeIcon mx-1 d-flex align-items-center justify-content-center"
                  style={{ fontWeight: "2rem", fontSize: "1.5rem" }}
                >
                  <GTranslateWidget />
                </div>
                <div
                  onClick={handleLogOut}
                  className="logOut d-flex align-items-center justify-content-center"
                >
                  <Tooltip title="Log Out" placement="left">
                    <PoweroffOutlined
                      style={{
                        marginTop: "6px",
                        fontWeight: "2rem",
                        marginLeft: "0rem !important",
                        fontSize: "1.5rem",
                        marginRight: "10px",
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            </div>
          ) : (
            <div onClick={handleMenu} className="bar">
              <i style={{ fontSize: "2rem" }} className="bi bi-list"></i>
            </div>
          )}
        </div>

        <ModalStl
          title="Receive Email Notification"
          open={isModalVisible}
          onCancel={closeModal}
          footer={null}
        >
          <Divider />
          <p className="emailNoty">
            Do you want to recevie email notification on{" "}
            {configData?.USER_EMAIL}
          </p>
          <div className="checkBoxContainer">
            <label>
              <input
                type="checkbox"
                className="checkBoxModal"
                checked={clientMailTure}
                onChange={handleCheckbox}
              />
            </label>
            <Button className="buttonModal" onClick={handleSave}>
              Save
            </Button>
          </div>
        </ModalStl>
      </nav>

      <div className={`sidebar ${menuClicked ? "sidebar-open" : ""}`}>
        <div
          onClick={handleMenu}
          style={{ borderBottom: "2px solid #DDE1E6", marginTop: "0.5rem" }}
          className="bar text-end"
        >
          <i
            style={{
              fontSize: "2rem",
              verticalAlign: "0.875em",
              cursor: "pointer",
              marginRight: "1rem",
            }}
            className={`bi ${menuClicked ? "bi-x" : "bi-list"}`}
          ></i>
        </div>
        <div style={{ height: "90%" }} className="collInner">
          <div className="globeIcon d-flex align-items-center px-3 justify-center">
            <GTranslateWidget />
          </div>
          <div
            onClick={handleLogOut}
            style={{ height: "3rem", cursor: "pointer" }}
            className="logOut text-start d-flex align-items-center"
          >
            <p style={{ color: "black" }} className="my-2 px-3">
              Log Out
            </p>
            <i style={{ color: "black" }} className="bi bi-box-arrow-right"></i>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

const ModalStl = newStyled(Modal)`
:where(.css-dev-only-do-not-override-1kf000u).ant-modal .ant-modal-title {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    color: #003C5D !important;
}
`;

export default Navbar;
